import { Component, Input } from '@angular/core';
import { UiThemeService } from 'src/app/core/services/ui-theme.service';
import { AlertService } from 'src/app/services/alert.service';

export type ThemeSwitchVariant = 'menu-item' | 'button';

/**
 * Klasik ve modern kabukların ikisinde de kullanılan tema geçiş kontrolü.
 * Tek kaynak olması için ayrı bileşen: metin ve davranış iki yerde tekrarlanmaz.
 */
@Component({
  selector: 'app-theme-switch',
  templateUrl: './theme-switch.component.html',
  styleUrls: ['./theme-switch.component.scss']
})
export class ThemeSwitchComponent {

  /** menu-item: dropdown içinde bir satır. button: bağımsız buton. */
  @Input() variant: ThemeSwitchVariant = 'menu-item';

  constructor(
    private uiThemeService: UiThemeService,
    private alertService: AlertService
  ) { }

  get isVisible(): boolean {
    return this.uiThemeService.isSwitchVisible;
  }

  get isModern(): boolean {
    return this.uiThemeService.isModern;
  }

  get label(): string {
    return this.isModern ? 'Eski tasarıma dön' : 'Yeni tasarımı dene';
  }

  get icon(): string {
    return this.isModern ? 'bx bx-undo' : 'bx bx-palette';
  }

  toggle(): void {
    this.uiThemeService.toggle();

    if (this.uiThemeService.isModern) {
      this.alertService.showSuccessToast(
        'Yeni tasarım açıldı. İstediğiniz zaman profil menüsünden eski tasarıma dönebilirsiniz.'
      );
    } else {
      this.alertService.showSuccessToast('Eski tasarıma dönüldü.');
    }
  }
}
